/**
 * BLOCK: Column - Save Block
 */

import classnames from 'classnames';
import Title from './components/Title';
import HowToChildDesc from './components/HowToChildDesc';
import HowToChildPositionClasses from './classes';
import HowToChildSeparator from './components/HowToChildSeparator';
import CallToAction from './components/CallToAction';
import HowToChildIconImage from './components/HowToChildIconImage';

export default function save(props) {
	const {
		iconimgPosition,
		/* eslint-disable */
		block_id,
		seperatorStyle,
		ctaType,
		ctaLink,
		ctaTarget,
		className,
		howtoChildTitle,
		headingDesc,
		showTitle,
		showDesc,
		seperatorPosition,
	} = props.attributes;

	// Get Image components.
	const isImage = <HowToChildIconImage attributes={props.attributes} />;

	let iconImagehtml = isImage;
	let seperatorPositions = seperatorPosition;
	const seperatorHtml = <HowToChildSeparator attributes={props.attributes} />;
	let showSeperator = true;

	if (
		seperatorPosition === 'after_icon' &&
		(iconimgPosition === 'above-title' || iconimgPosition === 'below-title')
	) {
		showSeperator = false;
		iconImagehtml = (
			<>
				{isImage}
				{'none' !== seperatorStyle && seperatorHtml}
			</>
		);
	}

	if (
		seperatorPosition === 'after_icon' &&
		(iconimgPosition !== 'above-title' || iconimgPosition !== 'below-title')
	) {
		seperatorPositions = 'after_title';
	}

	if (
		iconimgPosition === 'below-title' &&
		seperatorPosition === 'after_title'
	) {
		showSeperator = false;
		iconImagehtml = (
			<>
				{'none' !== seperatorStyle && seperatorHtml}
				{isImage}
			</>
		);
	}
	// Get description and seperator components.
	const desc = (
		<>
			{'none' !== seperatorStyle &&
				seperatorPositions === 'after_title' &&
				showSeperator &&
				seperatorHtml}
			<div className="wpsp-ifb-text-wrap">
				{showDesc && '' !== headingDesc && (
					<HowToChildDesc
						attributes={props.attributes}
						setAttributes="not_set"
					/>
				)}
				{'none' !== seperatorStyle &&
					seperatorPositions === 'after_desc' &&
					seperatorHtml}
				{ctaType !== 'none' && (
					<CallToAction attributes={props.attributes} />
				)}
			</div>
		</>
	);

	// Get Title components.
	const titleText = (
		<div className="wpsp-ifb-title-wrap">
			{'none' !== seperatorStyle &&
				seperatorPositions === 'after_prefix' &&
				seperatorHtml}
			{showTitle && '' !== howtoChildTitle && (
				<Title attributes={props.attributes} setAttributes="not_set" />
			)}
		</div>
	);

	const output = (
		<div
			className={classnames(
				'wpsp-how-to__content-wrap',
				ctaType === 'all' ? ' wpsp-how-to_cta-type-all' : '',
				...HowToChildPositionClasses(props.attributes)
			)}
		>
			<div className="wpsp-ifb-content">
				{iconimgPosition === 'above-title' && (
					<>
						{iconImagehtml}
						{titleText}
						{desc}
					</>
				)}

				{iconimgPosition === 'below-title' && (
					<>
						{titleText}
						{iconImagehtml}
						{desc}
					</>
				)}

				{iconimgPosition === 'below-desc' && (
					<>
						{titleText}
						{desc}
						{iconImagehtml}
					</>
				)}
			</div>
		</div>
	);

	let target = '';
	if (ctaTarget) {
		target = '_blank';
	}

	return (
		<div
			className={classnames(
				className,
				'wpsp-howto-child__outer-wrap',
				/* eslint-disable */
				`wpsp-block-${block_id}`
				/* eslint-enable */
			)}
		>
			{ctaType === 'all' && (
				/* eslint-disable */<a
					href={ctaLink}
					className="wpsp-howto-child-link-wrap wpsp-how-to__link-to-all"
					target={target}
					aria-label={'HowToChild Link'}
					rel="noopener noreferrer"
				></a> /* eslint-enable */
			)}
			{output}
		</div>
	);
}
